// extracted by mini-css-extract-plugin
module.exports = {"component":"pagination-component--3jrpf"};